import { styled } from "@mui/material/styles";

export const TicketContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: theme.space._600,
  width: "min-content",
  alignSelf: "strech",

  "@media (max-width: 900px)": {
    width: "100%",
  },
}));

export const StyledForm = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: theme.space._600,
}));

export const StyledBlueSpan = styled("span")(({ theme }) => ({
  color: theme.colors["blue.400"]
}));